import { IonContent, IonPage, withIonLifeCycle } from "@ionic/react";
import moment from "moment";
import React from "react";
import AcrofitHeader from "../components/AcrofitHeader";
import { syncAlimentos } from "../components/Funciones";
import TablaCalorias from "../components/TablaCalorias";

class RegistroPage extends React.Component{

    tablas = [] as Array<TablaCalorias|null>

    ionViewDidEnter(){
        syncAlimentos()
        this.tablas.forEach(tabla => {
            tabla?.update()
        })
    }

    render(){
        return (
            <IonPage>
                <AcrofitHeader />
                <IonContent className="no-bg">
                    <TablaCalorias ref={c => this.tablas.push(c)} fecha={moment().format()} title="Calorías consumidas hoy" />
                </IonContent>
            </IonPage>
        )
    }
}

export default withIonLifeCycle(RegistroPage)